<div class="scroll-wrapper" *ngIf="commentedData?.length > 0; else noComments">
  <button class="scroll-btn left" (click)="scrollLeft()">‹</button>

  <div class="scroll-background">
    <span class="comment-title-tag">Commented By Clinician</span>
    <div class="comment-cards-container" #scrollContainer>
      <div
        class="comment-card"
        *ngFor="let comment of commentedData"
        (click)="handleOnView(comment)"
      >
        <div class="comment-header">
          <span class="section">{{
            getSectionName(comment?.sectionName)
          }}</span>
          <span class="timestamp">{{
            comment?.createdAt | date : "short"
          }}</span>
        </div>
        <div class="comment-body">Comment: {{ comment?.comment }}</div>
      </div>
    </div>
  </div>

  <button class="scroll-btn right" (click)="scrollRight()">›</button>
</div>

<ng-template #noComments>
  <p>No Comments Available.</p>
</ng-template>
